import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TrustStrip from '../components/TrustStrip';
import FleetSection from '../components/FleetSection';
import HowItWorks from '../components/HowItWorks';
import PopularRoutes from '../components/PopularRoutes';
import ReviewsSection from '../components/ReviewsSection';
import Footer from '../components/Footer';
import MobileStickyButton from '../components/MobileStickyButton';

/**
 * Russian Homepage variant
 * Same content as English but with Russian SEO meta tags
 * This enables hreflang targeting for Russian market
 */
const HomePageRu = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <HeroSection />
        <TrustStrip />
        <ReviewsSection />
        <PopularRoutes />
        <HowItWorks />
        <FleetSection />
      </main>
      <Footer />
      <MobileStickyButton />
    </div>
  );
};

export default HomePageRu;
